import { CONTENT_TYPE } from "../../Const/const";
import RawApi from "../rawApi";


class ContestApi extends RawApi{
    VERIFY_CONTEST_ENDPOINT = '/api/contestverify'
    REGISTER_PARTICIPANT_ENDPOINT = '/api/register-participant'

    async verifyCurrentContest(contestToken){
        const payload = {
            contestToken
        }
        return this.post(this.VERIFY_CONTEST_ENDPOINT, payload, CONTENT_TYPE.URLENCODED)
    }

    async registerParticipant(contestId, userId){
        const payload = {
            contestId,
            userId
        }
        return this.post(this.REGISTER_PARTICIPANT_ENDPOINT, payload, CONTENT_TYPE.URLENCODED)
    }

}

export default new ContestApi()